import { getCountriesByIso2 } from '../../@data-loaders/get-countries-by-iso2';
import { getPlan } from '../../@data-loaders/get-plan';
import type { Field } from '../../shared/interfaces';

const shortInterval: Record<string, string> = {
    days: `day`,
    months: `mo`,
    years: `year`,
};

export const payment_currency: Field = {
    feedback: false,
    // eslint-disable-next-line max-params-no-constructor/max-params-no-constructor
    async mutate(element, elements: any, publicConfig, options, form) {
        const planCode = elements.plan_code?.input?.value;
        if (!planCode) {
            throw new Error(`Missing plan_code. Make sure your url is correct or try another link.`);
        }

        const plan = await getPlan(`code-${planCode}`);
        const select = element.input as HTMLSelectElement;

        if (plan.currencies.length === 0) {
            throw new Error(`We could not obtain plan currencies. Please try again later.`);
        }

        let trial = ``;
        if (plan.trial_length) {
            trial = `${plan.trial_length} ${plan.trial_unit} free trial, then `;
        }

        let period = ``;
        if (plan.interval_length === 1) {
            period = `/${shortInterval[plan.interval_unit] ?? plan.interval_unit}`;
        } else {
            period = ` every ${plan.interval_length} ${plan.interval_unit}`;
        }

        plan.currencies.forEach((price: any) => {
            const option = document.createElement(`option`);

            if (price.currency === `USD`) {
                option.label = `${trial}$${price.unit_amount}${period}`;
            } else {
                option.label = `${trial}${price.unit_amount} ${price.currency}${period}`;
            }

            option.value = price.currency;
            select.options.add(option);
        });

        if (plan.currencies.length === 1) {
            select.disabled = true;
            return;
        }

        const countriesByIso2 = await getCountriesByIso2();
        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const matchingCountryArray = Object.entries(countriesByIso2).find(([, countryInfo]: [string, any]) => {
            return countryInfo.timeZones.find((countryTimeZone: string) => {
                return countryTimeZone === userTimeZone;
            });
        });

        const matchingCountry: any = matchingCountryArray?.[1];
        if (matchingCountry) {
            const isNativeCurrencyAvailable = plan.currencies.some((price: any) => {
                return price.currency === matchingCountry.currency;
            });

            if (isNativeCurrencyAvailable) {
                select.value = matchingCountry.currency;
            } else {
                select.value = `USD`;
            }
        }
    },
};
